import { render, staticRenderFns } from "./catePlantform.vue?vue&type=template&id=f7f53282&scoped=true&"
import script from "./catePlantform.vue?vue&type=script&lang=js&"
export * from "./catePlantform.vue?vue&type=script&lang=js&"
import style0 from "./catePlantform.vue?vue&type=style&index=0&id=f7f53282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f53282",
  null
  
)

export default component.exports